export default "__VITE_ASSET__CoZD$eYb__"